module.exports = __webpack_public_path__ + "img/admin.246924ed.svg";